import React from 'react'
import { Send, Bell, Users, Link as LinkIcon } from 'lucide-react'


export default function PushNotificationForm({ form, setForm, handleSubmit, loading }) {
    const linkType = form.linkType || 'none';
    return (
        <div className="max-w-2xl mx-auto mt-6 bg-white rounded-xl shadow p-6">

            {/* Header */}
            <div className="flex items-center gap-2 mb-2">
                <Bell className="text-blue-600" size={22} />
                <h2 className="text-lg font-semibold text-gray-800">
                    Send Push Notification
                </h2>
            </div>

            {/* Required Note */}
            {/* <p className="text-sm text-gray-500 mb-6">
                    Fields marked with <span className="text-red-500">*</span> are required
                </p> */}

            {/* Form */}

            <form className="space-y-5" onSubmit={handleSubmit}>

                {/* Title */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Notification Title <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        required
                        placeholder="Enter notification title"
                        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={form.title}
                        onChange={(e) => setForm({ ...form, title: e.target.value })}
                    />
                </div>

                {/* Body */}
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Notification Body <span className="text-red-500">*</span>
                    </label>
                    <textarea
                        rows="4"
                        required
                        placeholder="Enter notification message"
                        className="w-full px-4 py-2 border rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
                        value={form.body}
                        onChange={(e) => setForm({ ...form, body: e.target.value })}
                    />
                </div>

                {/* User Type Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    {/* User Status */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            User Status <span className="text-red-500">*</span>
                        </label>
                        <select
                            required
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={form.userStatus}
                            onChange={(e) => setForm({ ...form, userStatus: e.target.value })}
                        >
                            <option value="">Select status</option>
                            <option value="active">Active Users</option>
                        </select>
                    </div>

                    {/* User Plan */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            User Plan <span className="text-red-500">*</span>
                        </label>
                        <select
                            required
                            className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={form.userType}
                            onChange={(e) => setForm({ ...form, userType: e.target.value })}
                        >
                            <option value="">Select plan</option>
                            <option value="free">Free Users</option>
                            <option value="trial">Trial Users</option>
                            <option value="premium">Premium Users</option>
                            <option value="all">All Plans</option>
                        </select>
                    </div>
                </div>

                {/* Deep link target */}
                <div className="border rounded-lg p-4 bg-gray-50">
                    <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-3">
                        <LinkIcon size={16} className="text-purple-600" />
                        Open when tapped <span className="text-xs text-gray-500">(optional)</span>
                    </label>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        <select
                            value={linkType}
                            onChange={(e) => setForm({ ...form, linkType: e.target.value, linkId: '', linkUrl: '' })}
                            className="px-3 py-2 border rounded-lg text-sm"
                        >
                            <option value="none">Nothing (just notification)</option>
                            <option value="post">Open a Post</option>
                            <option value="poll">Open a Poll</option>
                            <option value="url">Open a URL</option>
                        </select>
                        {(linkType === 'post' || linkType === 'poll') && (
                            <input
                                type="text"
                                placeholder={`Paste the ${linkType} ID`}
                                value={form.linkId || ''}
                                onChange={(e) => setForm({ ...form, linkId: e.target.value })}
                                className="px-3 py-2 border rounded-lg text-sm md:col-span-2"
                            />
                        )}
                        {linkType === 'url' && (
                            <input
                                type="url"
                                placeholder="https://..."
                                value={form.linkUrl || ''}
                                onChange={(e) => setForm({ ...form, linkUrl: e.target.value })}
                                className="px-3 py-2 border rounded-lg text-sm md:col-span-2"
                            />
                        )}
                    </div>
                </div>

                {/* Info */}
                <div className="flex items-start gap-2 bg-blue-50 p-3 rounded-lg text-sm text-blue-700">
                    <Users size={18} className="mt-0.5" />
                    <p>
                        Notification will be sent only to <b>active users</b> under the selected plan.
                    </p>
                </div>

                {/* Submit */}
                <div className="flex justify-end">
                    <button
                        type="submit"
                        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded-lg transition"
                        disabled={loading}
                    >
                        <Send size={16} />
                        <span>
                            {
                                loading ? 'Sending...' : 'Send Notification'
                            }
                        </span>
                    </button>
                </div>

            </form>
        </div>

    )
}
